import { gql } from "@apollo/client";

export const CONTRATOS_VIGENTES = gql`
query ContratosVigentes($input: ContratosAsignadosInput!) {
    contratosVigentes(input: $input) {
        idEvaluacionProfesional
        idEvaluacion
        idPaciente
        idTipoModulo
        paciente
        codigoSAP
        periodoSuspension
        programa
        profesional
        idTipoProfesional
        tipoProfesional
        planCuidado
        estado
        estadoPaciente
        direccion
        mes
        anio
        frecuencia
        idFrecuencia
        fechaAsignacion
        fechaDesde
        fechaHasta
        cantidadVisitas
        cantidadVisitasEsperadas
        urgencias
        cantidadNotificaciones
        vigenciaReemplazo
        fechaDesdeReemplazo
        fechaHastaReemplazo
        tieneMasDeUnReemplazo
        idFiguraProfesional
        figuraProfesional
        fechaUltimaVisita
    }
}`;